import { PropTypes } from 'react';
import Icon from 'noc/components/icon';

const Error = ({ errorTitle, errorMessage }) => (
    <div className="cn-no-results">
        <div className="cn-no-results__mssg">
            <Icon type="cn-icon" icon="icon-alert" />
            <h2 className="cn-pgtitle">{errorTitle}</h2>
            <p>{errorMessage}</p>
        </div>
    </div>
);

Error.propTypes = {
    errorTitle: PropTypes.string,
    errorMessage: PropTypes.string
};


export default Error;


// WEBPACK FOOTER //
// ./app/error/index.jsx